import React, { useEffect, useState } from "react";
import { api, shortAddr, fmtUSD, CHAIN_META } from "@/lib/api";

export default function DonationTicker() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    let on = true;
    const load = async () => {
      try {
        const r = await api.get("/donations/recent?limit=20");
        if (on) setRows(r.data || []);
      } catch (e) { /* ignore */ }
    };
    load();
    const t = setInterval(load, 15000);
    return () => { on = false; clearInterval(t); };
  }, []);

  const list = rows;

  if (list.length === 0) {
    return (
      <div
        data-testid="donation-ticker-empty"
        className="w-full border-y border-[#3A2E1C] bg-[#141008]/70 py-3 text-center"
      >
        <span className="mono text-xs text-stone-500 uppercase tracking-widest">
          · awaiting first transmission · be the first to cremate your dust ·
        </span>
      </div>
    );
  }

  const doubled = [...list, ...list];

  return (
    <div
      data-testid="donation-ticker"
      className="relative w-full overflow-hidden border-y border-[#3A2E1C] bg-[#141008]/70"
    >
      <div className="absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-[#0A0906] to-transparent z-10 pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-[#0A0906] to-transparent z-10 pointer-events-none" />
      <div className="marquee-track flex gap-10 py-3">
        {doubled.map((r, i) => {
          const meta = CHAIN_META[r.chain] || { name: r.chain, color: "#FFC940" };
          return (
            <div key={i} className="flex items-center gap-3 text-sm">
              <span
                className="inline-block w-2 h-2 rounded-full"
                style={{ backgroundColor: meta.color, boxShadow: `0 0 8px ${meta.color}` }}
              />
              <span className="mono text-stone-400">{shortAddr(r.wallet)}</span>
              <span className="text-stone-300">cremated</span>
              <span className="font-semibold text-[#FFD54F] mono">
                {Number(r.amount).toLocaleString()} ${r.token_symbol}
              </span>
              <span className="text-stone-500">·</span>
              <span className="mono text-[#FFC940]">{fmtUSD(r.usd_value)}</span>
              <span className="text-stone-500">·</span>
              <span className="text-xs uppercase tracking-wider text-stone-400">on {meta.name}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
